import React, { useState, useCallback, useEffect, useContext } from "react";
import Switch from "react-switch";
import SelectSearch from "react-select-search";

// get our fontawesome imports
import {
  faSearch,
  faFileMedicalAlt,
  faCheckCircle,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//httpClient
import ChartsClient from "./../../httpClient/Charts";
import AuthenticationClient from "./../../httpClient/Authentication";

//Context API for User Info
import { InfoContext } from "./../../context/InfoContext";

//react-bootstrap
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import Spinner from "react-bootstrap/Spinner";

//components
import ChartDetails from "./ChartDetails";

//styling
import "./Charts.css";

const Charts = () => {
  //current user Info
  const { info, setInfo } = useContext(InfoContext);
  const [chartStatuses, setChartStatuses] = useState(null);
  const [currentRecord, setCurrentRecord] = useState(null); //Set Current Record variable
  const [loading, setLoading] = useState({
    currentRecordLoading: false,
    chartsListLoading: false,
    currentRecordDetailsLoading: false,
    chartQuestionsLoading: false,
  });
  const [reloadCurrentRecord, setReloadCurrentRecord] = useState(false);
  const [chartsList, setChartsList] = useState([]);
  const [chartsInQueueList, setChartsInQueueList] = useState([]);
  const [filteredChartsList, setFilteredChartsList] = useState([]);
  const [copaBasesList, setCopaBasesList] = useState([]);

  const [incidentCounties, setIncidentCounties] = useState([]);
  const [timesEnRoute, setTimesEnRoute] = useState([]);

  const [selectedCopaBase, setSelectedCopaBase] = useState("");
  const [selectedIncidentCounty, setSelectedIncidentCounty] = useState("");
  const [selectedTimeEnRoute, setSelectedTimeEnRoute] = useState("");

  const updateLoading = useCallback((key, value) => {
    setLoading((loading) => {
      return {
        ...loading,
        [key]: value,
      };
    });
  }, []);

  //Fetch Active Charts
  useEffect(() => {
    fetchChartStatuses();
    //fetchActiveCharts();
    fetchChartsInEmployeeQueue();
    fetchUserBases();
  }, []);

  //Fetch Active Charts fo Copa Base
  useEffect(() => {
    if (selectedCopaBase.length > 0) {
      fetchChartsSelectedBase();
    }
  }, [selectedCopaBase]);

  useEffect(() => {
    if (selectedIncidentCounty.length > 3 && selectedTimeEnRoute.length > 3) {
      setFilteredChartsList(
        chartsList.filter(
          (chart) =>
            chart.eScene_21.toLowerCase() ===
              selectedIncidentCounty.toLowerCase() &&
            (chart.timeEnRouteDate.toLowerCase() ===
              selectedTimeEnRoute.toLowerCase() ||
              chart.timeEnRouteDate.replace(/\//g, "").trim() ===
                selectedTimeEnRoute.replace(/\//g, "").toLowerCase())
        )
      );
    } else {
      if (selectedIncidentCounty.length > 3) {
        setFilteredChartsList(
          chartsList.filter(
            (chart) =>
              chart.eScene_21.toLowerCase() ===
              selectedIncidentCounty.toLowerCase()
          )
        );
      } else if (selectedTimeEnRoute.length > 3) {
        setFilteredChartsList(
          chartsList.filter(
            (chart) =>
              chart.timeEnRouteDate.toLowerCase() ===
                selectedTimeEnRoute.toLowerCase() ||
              chart.timeEnRouteDate.replace(/\//g, "").trim() ===
                selectedTimeEnRoute.replace(/\//g, "").toLowerCase()
          )
        );
      } else {
        setFilteredChartsList(chartsList);
      }
    }
  }, [selectedIncidentCounty, selectedTimeEnRoute, chartsList]);

  const reloadChartsList = () => {
    // fetchChartStatuses();
    // //fetchActiveCharts();
    // fetchChartsInEmployeeQueue();
    // fetchUserBases();

    setCurrentRecord(null);
    fetchChartsSelectedBase();
    fetchChartsInEmployeeQueue();
  };

  const fetchChartsSelectedBase = () => {
    updateLoading("chartsListLoading", true);
    ChartsClient.getAllActiveChartsForBase(selectedCopaBase)
      .then((data) => {
        updateLoading("chartsListLoading", false);
        setCurrentRecord(null);
        // debugger;
        setChartsList(data.activeCharts);
        setIncidentCounties(data.incidentCounties);
        setTimesEnRoute(data.timesEnRoute);
      })
      .catch((err) => {
        updateLoading("chartsListLoading", false);
        // setErrorMessage(err.response.data.Message);
      });
  }

  const fetchUserBases = () => {
    AuthenticationClient.fetchUserRecord(info.email)
      .then((data) => {
        setCopaBasesList(
          data.copaUserBases
            .filter((base) => base.isActive)
            .map((a) => ({ name: a.name, value: a.name }))
        );
      })
      .catch((err) => {
        // setErrorMessage(err.response.data.Message);
      });
  };

  const fetchChartStatuses = () => {
    ChartsClient.getChartStatuses(info.email)
      .then((data) => {
        setChartStatuses(data);
      })
      .catch((err) => {});
  };

  const fetchChartsInEmployeeQueue = () => {
    ChartsClient.getChartsInEmployeeQueue(info.email)
      .then((data) => {
        setCurrentRecord(null);
        setChartsInQueueList(data);
      })
      .catch((err) => {
        // setErrorMessage(err.response.data.Message);
      });
  };

  const fetchActiveCharts = () => {
    updateLoading("chartsListLoading", true);
    ChartsClient.getAllActiveCharts(info.email)
      .then((data) => {
        updateLoading("chartsListLoading", false);
        setCurrentRecord(null);
        // debugger;
        setChartsList(data.activeCharts);
        setIncidentCounties(data.incidentCounties);
        setTimesEnRoute(data.timesEnRoute);
      })
      .catch((err) => {
        updateLoading("chartsListLoading", false);
        // setErrorMessage(err.response.data.Message);
      });
  };

  const filterCharts = (value) => {
    let searchValue = value.replace(/\//g, "").trim();
    setFilteredChartsList(
      chartsList.filter(
        (chart) =>
          chart.dAgency_03.toLowerCase().includes(searchValue.toLowerCase()) ||
          chart.eResponse_03
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          chart.chartDate
            .replace(/\//g, "")
            .trim()
            .includes(searchValue.toLowerCase())
      )
    );
  };

  let chartsInQueue = chartsInQueueList.map((record, key) => (
    <ListGroup.Item
      key={key}
      variant={currentRecord && !currentRecord.isActive ? "" : ""}
      active={currentRecord && key === currentRecord.id ? true : false}
      onClick={() => setCurrentRecord(record)}
    >
      <strong>{record.chartDate}</strong>:{" "}
      <span
        className={
          record.integration === "Ground"
            ? "integrationGround"
            : "integrationAir"
        }
      >
        {record.integration}
      </span>{" "}
      {record.dAgency_03} ({record.integrationIdentifier})
    </ListGroup.Item>
  ));

  let charts = chartsList.map((record, key) => (
    <ListGroup.Item
      key={record.id}
      variant={currentRecord && !currentRecord.isActive ? "" : ""}
      active={currentRecord && record.id === currentRecord.id ? true : false}
      onClick={() => setCurrentRecord(record)}
    >
      <strong>{record.chartDate}</strong>:{" "}
      <span
        className={
          record.integration === "Ground"
            ? "integrationGround"
            : "integrationAir"
        }
      >
        {record.integration}
      </span>{" "}
      {record.dAgency_03} ({record.integrationIdentifier}) 
    </ListGroup.Item>
  ));

  let filteredCharts = filteredChartsList.map((record, key) => (
    <ListGroup.Item
      key={key}
      variant={currentRecord && !currentRecord.isActive ? "" : ""}
      active={currentRecord && record.id === currentRecord.id ? true : false}
      onClick={() => setCurrentRecord(record)}
    >
      <strong>{record.chartDate}</strong>:{" "}
      <span
        className={
          record.integration === "Ground"
            ? "integrationGround"
            : "integrationAir"
        }
      >
        {record.integration}
      </span>{" "}
      {record.dAgency_03} ({record.integrationIdentifier})
    </ListGroup.Item>
  ));

  if (currentRecord != null) {
    return (
      <ChartDetails
        currentRecord={currentRecord}
        setCurrentRecord={setCurrentRecord}
        reloadChartsList={reloadChartsList}
      />
    );
  }

  return (
    <div className="innerBody">
      <Container fluid>
        <Row>
          <Col xs={5}>
            {/* <InputGroup className="mb-3">
                            <FormControl
                                placeholder={`Filter ${charts.length} Charts`}
                                onChange={(e)=>filterCharts(e.target.value)}
                            />
                        </InputGroup> */}

            {chartsInQueueList.length > 0 && (
              <div>
                <h4 className="section-header">Continue Review</h4>
                <br />
                <div>
                  <ListGroup>{chartsInQueue}</ListGroup>
                </div>
                <br />
              </div>
            )}

            <br />
            <h4 className="section-header">Filters</h4>

            {!loading.chartsListLoading && (
              <Row>
                <Col xs={5}>
                  <SelectSearch
                    options={incidentCounties}
                    value={selectedIncidentCounty}
                    name="incidentCounty"
                    placeholder="Filter By Incident County"
                    onChange={(e) => setSelectedIncidentCounty(e)}
                  />
                </Col>
                <Col xs={5}>
                  <SelectSearch
                    options={timesEnRoute}
                    value={selectedTimeEnRoute}
                    name="timeEnRoute"
                    placeholder="Filter By Time En Route"
                    onChange={(e) => setSelectedTimeEnRoute(e)}
                  />
                </Col>
              </Row>
            )}

            <hr />

            <h4 className="section-header">
              Pending Review ({filteredChartsList.length})
            </h4>
            <br />
            {loading.chartsListLoading && (
              <Spinner animation="border" variant="primary" />
            )}
            {!loading.chartsListLoading && (
              <div className="chart-list">
                <ListGroup>
                  {filteredCharts}
                  {/* {filteredChartsList.length > 0 ? filteredCharts : charts} */}
                </ListGroup>
              </div>
            )}
          </Col>
          <Col>
            <Container>
              <Row className="justify-content-md-center">
                <Col md="auto">
                  {chartStatuses && (
                    <h4>
                      <FontAwesomeIcon icon={faCheckCircle} color="green" />{" "}
                      Completed <strong>{chartStatuses["Completed"]}</strong>
                    </h4>
                  )}
                </Col>
                <Col md="auto">
                  {chartStatuses && (
                    <h4>
                      <FontAwesomeIcon icon={faInfoCircle} color="orange" /> In
                      Review <strong>{chartStatuses["In Review"]}</strong>
                    </h4>
                  )}
                </Col>
              </Row>
            </Container>
            <hr />

            <div className="charts-placeholder">
              <section className="hero is-primary is-halfheight">
                <div className="hero-body">
                  <div className="container textAlignCenter">
                    <FontAwesomeIcon icon={faFileMedicalAlt} size="6x" />
                    <hr />
                    <br />
                    <h3 className="title">Select a Base to get started</h3>

                    <Row className="justify-content-md-center">
                      <Col xs={10}>
                        <SelectSearch
                          options={copaBasesList}
                          value={selectedCopaBase}
                          name="name"
                          placeholder="User Bases"
                          onChange={(e) => setSelectedCopaBase(e)}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </section>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Charts;
